



















































import _ from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ViewDetail extends Vue {
  @Prop({ default: '' }) public header!: string
  @Prop({
    default: [{
      title: '',
      icon: '',
      data: [{ text: '', value: '' }]}],
    }) public detail!: [{ title: string, icon: string, data: [{ text: string, value: string }]}]

  private classCard = {
    'pa-10': true,
    'pb-2': true,
    // 'pa-10': this.$vuetify.breakpoint.mdAndUp,
    // 'pb-0': this.$vuetify.breakpoint.mdAndUp
  }
}
